import axios from 'axios'
import vue from 'vue'
import router from '../router';
// 默认请求配置
const defaultOptions = {
  method: 'post', // 请求 type  get post delete header put
  withCredentials: true, // 设置该属性可以把 cookie 信息传到后台
};
// 默认头信息
const defaultHeaders = {
  // headers 的键是不区分大小写的
  Accept: 'application/json',
  'Content-Type': 'application/json; charset=utf-8',
  Score:"before"
};
export function callApi({
  url,
  data = {},
  option = {}
}) {
  const options = { ...defaultOptions, ...option }
  const { method, headers } = options
  const token = localStorage.getItem('data') ? JSON.parse(localStorage.getItem('data')).token : ''
  // 混合默认头和配置头信息
  options.headers = {
    ...defaultHeaders,
    ...headers,
    Authorization: token,
  };
  if (method !== 'get' && method !== 'head') {
    // formData处理方式
    if (data instanceof FormData) {
      options.data = data;
      options.headers = {
        ...headers,
        'x-requested-with': 'XMLHttpRequest',
        'cache-control': 'no-cache',
      }
    } else {
      Object.keys(data).forEach((item) => {
        if (data[item] === null || data[item] === undefined || data[item] === '') {
          delete data[item]
        }
      })
      options.data = JSON.stringify({ data: data })
    }
  }
  return axios({
    url,
    ...options,
    data
  })
    .then((res) => {
      const { data: resData } = res || {};
      if (resData.code === 200) {
        return resData;
      }
      if (resData.code === '9998') {
        router.push({
          name: 'login'
        })
        return
      }
      vue.prototype.$Message.error(resData.msg || '获取数据出错');
      return Promise.reject(resData);
    })
    .catch((error) => Promise.reject(error))
}


// WEBPACK FOOTER //
// ./src/utils/https.js